/* eslint-disable no-unused-vars */
const download = (url, name) => {
  var xhr = new XMLHttpRequest();
  xhr.responseType = "blob";
  xhr.open("GET", url);
  xhr.onload = function(event) {
    var blob = xhr.response;
    saveBlob(blob, name);
  };
  xhr.send();
};


function saveBlob(blob, fileName) {
  var a = document.createElement("a");
  a.href = window.URL.createObjectURL(blob);
  a.download = fileName;
  a.dispatchEvent(new MouseEvent("click"));
}

export default download;



// export function saveOrOpenBlob(blob, fileName) {
//   console.log("saveOrOpenBlob");
//   window.requestFileSystem =
//     window.requestFileSystem || window.webkitRequestFileSystem;
//   window.requestFileSystem(
//     window.TEMPORARY,
//     1024 * 1024,
//     function(fs) {
//       fs.root.getFile(
//         fileName,
//         { create: true },
//         function(fileEntry) {
//           fileEntry.createWriter(
//             function(fileWriter) {
//               fileWriter.addEventListener(
//                 "writeend",
//                 function() {
//                   window.location = fileEntry.toURL();
//                 },
//                 false
//               );
//               fileWriter.write(blob, "_blank");
//             },
//             function() {}
//           );
//         },
//         function() {}
//       );
//     },
//     function() {}
//   );
// }